import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/user-avatar.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle-gray.svg'
import _imports_2 from '@/app/ui/assets/svg/lion-parcel-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-168c0148")

_pushScopeId("data-v-168c0148")
const _hoisted_1 = { class: "mitra-section mb-8" }
const _hoisted_2 = { class: "mitra-item" }
const _hoisted_3 = { class: "text-gray-500" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col mt-2"
}
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = { class: "w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden" }
const _hoisted_7 = {
  key: 1,
  src: _imports_0,
  class: "w-5 h-5 object-cover",
  alt: "User"
}
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "flex-1 flex-row flex justify-between" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_11 = { class: "w-full flex flex-col text-12px" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_14 = {
  key: 1,
  class: "text-gray-500 mt-1"
}
const _hoisted_15 = { class: "mitra-item mt-4" }
const _hoisted_16 = { class: "text-gray-500" }
const _hoisted_17 = { class: "flex items-center gap-2" }
const _hoisted_18 = { class: "w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden" }
const _hoisted_19 = {
  key: 1,
  src: _imports_0,
  class: "w-5 h-5 object-cover",
  alt: "User"
}
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = { class: "flex-1" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "w-full flex flex-col text-12px" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-row text-xs text-gray-500 mt-1"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4 h-4 mr-1",
  alt: "User"
}, null, -1)
const _hoisted_27 = {
  key: 1,
  class: "text-sm text-gray-500 mt-1"
}
const _hoisted_28 = {
  key: 1,
  class: "text-gray-500 mt-1"
}
const _hoisted_29 = { class: "mitra-item mt-4" }
const _hoisted_30 = { class: "text-gray-500" }
const _hoisted_31 = {
  key: 0,
  class: "flex flex-col mt-2"
}
const _hoisted_32 = { class: "flex items-center gap-2" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "w-8 h-8" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    class: "w-full h-full object-contain",
    alt: "Lion Parcel"
  })
], -1)
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = { class: "flex-1" }
const _hoisted_36 = { class: "w-full flex flex-col text-12px" }
const _hoisted_37 = { class: "font-bold" }
const _hoisted_38 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_39 = {
  key: 1,
  class: "text-gray-500 mt-1"
}
const _hoisted_40 = {
  key: 0,
  class: "mitra-item mt-4"
}
const _hoisted_41 = { class: "text-gray-500" }
const _hoisted_42 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_43 = { class: "flex items-center gap-2" }
const _hoisted_44 = { class: "flex -space-x-6" }
const _hoisted_45 = {
  key: 1,
  src: _imports_0,
  class: "w-5 h-5 object-cover",
  alt: "User"
}
const _hoisted_46 = { class: "text-sm font-medium" }
const _hoisted_47 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_48 = { class: "w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden" }
const _hoisted_49 = {
  key: 1,
  src: _imports_0,
  class: "w-5 h-5 object-cover",
  alt: "User"
}
const _hoisted_50 = { class: "flex flex-col" }
const _hoisted_51 = { class: "flex-1" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "w-full flex flex-col text-12px" }
const _hoisted_54 = { class: "font-bold" }
const _hoisted_55 = {
  key: 1,
  class: "text-gray-500 mt-1"
}
const _hoisted_56 = { class: "flex justify-between items-center mb-2 border-b border-gray-200 px-4" }
const _hoisted_57 = { class: "text-lg font-semibold" }
const _hoisted_58 = /*#__PURE__*/_createVNode("span", { class: "text-4xl font-thin" }, "×", -1)
const _hoisted_59 = {
  key: 0,
  class: "space-y-2 px-4 overflow-y-auto partner-history-container mr-3",
  style: {"max-height":"244px"}
}
const _hoisted_60 = { class: "w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden" }
const _hoisted_61 = {
  key: 1,
  src: _imports_0,
  class: "w-5 h-5 object-cover",
  alt: "User"
}
const _hoisted_62 = { class: "flex-1" }
const _hoisted_63 = { class: "font-medium" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = {
  key: 0,
  class: "flex flex-row text-xs text-gray-500 mt-1"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4 h-4 mr-1",
  alt: "User"
}, null, -1)
const _hoisted_67 = {
  key: 1,
  class: "text-sm text-gray-500 mt-1"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.partnerTitle')), 1),
      (_ctx.data.reporter?.partnerName)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                (_ctx.data.reporter?.avatar)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.data.reporter.avatar,
                      class: "w-full h-full object-cover"
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock("img", _hoisted_7))
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("p", {
                    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltip($event, _ctx.data.reporter.partnerCode))),
                    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltip($event, _ctx.data.reporter.partnerCode))),
                    class: "font-medium whitespace-nowrap cursor-default"
                  }, _toDisplayString(_ctx.ellipsisText(_ctx.mitraValueByCondition(_ctx.data.reporter), 28)), 33),
                  (_ctx.data.reporter.partnerTier)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode("img", {
                          width: "16",
                          height: "16",
                          src: require(`@/app/ui/assets/svg/level/${_ctx.level?.icon}.svg`),
                          alt: "level"
                        }, null, 8, ["src"]),
                        _createVNode("div", {
                          class: `text-xs font-medium text-${_ctx.level?.color}`
                        }, _toDisplayString(_ctx.level?.title), 3)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_OverlayPanel, {
                    ref: _ctx.data.reporter.partnerCode,
                    appendTo: "body",
                    class: "w-1/4",
                    style: {
                  backgroundColor: '#4D4D4D',
                  color: '#ffffff'
                }
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_11, [
                        _createVNode("div", _hoisted_12, _toDisplayString(_ctx.mitraValueByCondition(_ctx.data.reporter)), 1)
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _createVNode("p", _hoisted_13, _toDisplayString(_ctx.formatDateTime(_ctx.data.reporter?.date) || "-"), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createBlock("p", _hoisted_14, "-"))
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.escalationPartner')), 1),
      (_ctx.data.escalation?.length)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.escalation, (escalation, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: ["flex flex-col mt-2", {
            'opacity-50' : escalation?.finishAt
          }]
              }, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    (escalation?.avatar)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: escalation.avatar,
                          class: "w-full h-full object-cover"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock("img", _hoisted_19))
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("p", {
                        onMouseenter: ($event: any) => (_ctx.toggleTooltip($event, escalation.partnerCode)),
                        onMouseleave: ($event: any) => (_ctx.toggleTooltip($event, escalation.partnerCode)),
                        class: "font-medium whitespace-nowrap cursor-default"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.ellipsisText(_ctx.mitraValueByCondition(escalation), 28)) + " ", 1),
                        (escalation?.isYou)
                          ? (_openBlock(), _createBlock("span", _hoisted_22, "(" + _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.isYou')) + ")", 1))
                          : _createCommentVNode("", true)
                      ], 40, ["onMouseenter", "onMouseleave"]),
                      _createVNode(_component_OverlayPanel, {
                        ref: escalation.partnerCode,
                        appendTo: "body",
                        class: "w-1/4",
                        style: {
                    backgroundColor: '#4D4D4D',
                    color: '#ffffff'
                  }
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_23, [
                            _createVNode("div", _hoisted_24, _toDisplayString(_ctx.mitraValueByCondition(escalation)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1536)
                    ]),
                    (escalation?.finishAt)
                      ? (_openBlock(), _createBlock("div", _hoisted_25, [
                          _hoisted_26,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.finishedAt')) + " " + _toDisplayString(_ctx.formatDateTime(escalation?.finishAt)), 1)
                        ]))
                      : (_openBlock(), _createBlock("p", _hoisted_27, _toDisplayString(_ctx.formatDateTime(escalation?.date)), 1))
                  ])
                ])
              ], 2))
            }), 128)),
            (_ctx.data.escalationBefore?.length)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "text-red-lp-100 underline font-semibold cursor-pointer mt-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showEscalationModal = true))
                }, _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.lookAtPrev')), 1))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock("p", _hoisted_28, "-"))
    ]),
    _createVNode("div", _hoisted_29, [
      _createVNode("h3", _hoisted_30, _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.csAgent')), 1),
      (_ctx.data.agent?.partnerFullname || _ctx.data.agent?.partnerCode || _ctx.data.agent?.partnerName)
        ? (_openBlock(), _createBlock("div", _hoisted_31, [
            _createVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("p", {
                    onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleTooltip($event, _ctx.data.agent.partnerFullname))),
                    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleTooltip($event, _ctx.data.agent.partnerFullname))),
                    class: "font-medium cursor-default"
                  }, _toDisplayString(_ctx.ellipsisText(_ctx.data.agent.partnerFullname, 28)), 33),
                  _createVNode(_component_OverlayPanel, {
                    ref: _ctx.data.agent.partnerFullname,
                    appendTo: "body",
                    class: "w-1/4",
                    style: {
                  backgroundColor: '#4D4D4D',
                  color: '#ffffff'
                }
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_36, [
                        _createVNode("div", _hoisted_37, _toDisplayString(_ctx.data.agent.partnerFullname), 1)
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _createVNode("p", _hoisted_38, _toDisplayString(_ctx.formatDateTime(_ctx.data.agent?.date)), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createBlock("p", _hoisted_39, "-"))
    ]),
    (!_ctx.isSummary)
      ? (_openBlock(), _createBlock("div", _hoisted_40, [
          _createVNode("h3", _hoisted_41, _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.partnerFollower')), 1),
          (_ctx.data.followers?.length)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (!_ctx.showAllFollowers && _ctx.data.followers.length > 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_42, [
                      _createVNode("div", _hoisted_43, [
                        _createVNode("div", _hoisted_44, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.followers.slice(0, 3), (follower, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: index,
                              class: "w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden border-2 border-white"
                            }, [
                              (follower?.avatar)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    src: follower.avatar,
                                    class: "w-full h-full object-cover"
                                  }, null, 8, ["src"]))
                                : (_openBlock(), _createBlock("img", _hoisted_45))
                            ]))
                          }), 128))
                        ]),
                        _createVNode("span", _hoisted_46, _toDisplayString(_ctx.hasCurrentUser ? "Anda & " : "") + "+" + _toDisplayString(_ctx.displayedFollowerCount) + " " + _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.follower')), 1)
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_47, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.followers, (follower, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "flex items-center gap-2 mt-2"
                        }, [
                          _createVNode("div", _hoisted_48, [
                            (follower?.avatar)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: follower.avatar,
                                  class: "w-full h-full object-cover"
                                }, null, 8, ["src"]))
                              : (_openBlock(), _createBlock("img", _hoisted_49))
                          ]),
                          _createVNode("div", _hoisted_50, [
                            _createVNode("div", _hoisted_51, [
                              _createVNode("p", {
                                onMouseenter: ($event: any) => (_ctx.toggleTooltip($event, follower.partnerCode)),
                                onMouseleave: ($event: any) => (_ctx.toggleTooltip($event, follower.partnerCode)),
                                class: "font-medium whitespace-nowrap cursor-default"
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.ellipsisText(_ctx.mitraValueByCondition(follower), 28)) + " ", 1),
                                (follower.isYou)
                                  ? (_openBlock(), _createBlock("span", _hoisted_52, "(" + _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.isYou')) + ")", 1))
                                  : _createCommentVNode("", true)
                              ], 40, ["onMouseenter", "onMouseleave"]),
                              _createVNode(_component_OverlayPanel, {
                                ref: follower.partnerCode,
                                appendTo: "body",
                                class: "w-1/4",
                                style: {
                    backgroundColor: '#4D4D4D',
                    color: '#ffffff'
                  }
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_53, [
                                    _createVNode("div", _hoisted_54, _toDisplayString(_ctx.mitraValueByCondition(follower)), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1536)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])),
                (_ctx.data.followers.length > 1)
                  ? (_openBlock(), _createBlock("div", {
                      key: 2,
                      class: "text-red-lp-100 underline font-semibold cursor-pointer mt-2",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleFollowersList && _ctx.toggleFollowersList(...args)))
                    }, _toDisplayString(_ctx.showAllFollowers ? _ctx.$t('pusatResolusi.partnerSection.seeAlittle') : _ctx.$t('pusatResolusi.partnerSection.seeAll')), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock("p", _hoisted_55, "-"))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEscalationModal)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showEscalationModal = false))
        }, [
          _createVNode("div", {
            class: "bg-white rounded-lg pb-4 max-w-lg w-full mx-4 max-h-[80vh] overflow-y-auto",
            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode("div", _hoisted_56, [
              _createVNode("h2", _hoisted_57, _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.prevPartner')), 1),
              _createVNode("button", {
                class: "text-red-lp-100 hover:text-red-lp-700",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showEscalationModal = false))
              }, [
                _hoisted_58
              ])
            ]),
            (_ctx.data.escalationBefore?.length)
              ? (_openBlock(), _createBlock("div", _hoisted_59, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.escalationBefore, (escalation, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: ["flex items-center gap-4 py-2", {
              'border-b border-gray-200':
                index !== _ctx.data.escalationBefore.length - 1,
                'opacity-50' : escalation?.finishAt
            }]
                    }, [
                      _createVNode("div", _hoisted_60, [
                        (escalation?.avatar)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: escalation.avatar,
                              class: "w-full h-full object-cover"
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock("img", _hoisted_61))
                      ]),
                      _createVNode("div", _hoisted_62, [
                        _createVNode("p", _hoisted_63, [
                          _createTextVNode(_toDisplayString(_ctx.ellipsisText(_ctx.mitraValueByCondition(escalation), 28)) + " ", 1),
                          (escalation.isYou)
                            ? (_openBlock(), _createBlock("span", _hoisted_64, "(" + _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.isYou')) + ")", 1))
                            : _createCommentVNode("", true)
                        ]),
                        (escalation?.finishAt)
                          ? (_openBlock(), _createBlock("div", _hoisted_65, [
                              _hoisted_66,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('pusatResolusi.partnerSection.finishedAt')) + " " + _toDisplayString(_ctx.formatDateTime(escalation?.finishAt)), 1)
                            ]))
                          : (_openBlock(), _createBlock("p", _hoisted_67, _toDisplayString(_ctx.formatDateTime(escalation?.date)), 1))
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})